
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forward-mail",
      function () {
        return require("private-next-pages/forward-mail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/forward-mail"])
      });
    }
  